import { get } from 'pc-sales/utils/http';

/**
 * Theme image bundle returned by GET /v2/platform/setting/theme.
 * Shape matches Design page's stored value: each field is either an upload-response
 * object ({aws, oss, storageUrl, uri, ...}) or an empty string when missing.
 * /v2/platform/setting/theme 接口返回的主题图片。形状与 Design 页保存的一致：
 * 每个字段要么是上传响应对象（{aws,oss,storageUrl,uri,...}），缺失时为空字符串。
 */
export interface ThemeImageValue {
    aws?: string;
    oss?: string;
    storageUrl?: string;
    uri?: string;
    [key: string]: any;
}

export interface ThemeImages {
    favicon: ThemeImageValue | string;
    mainLogo: ThemeImageValue | string;
    squareLogo: ThemeImageValue | string;
    clientLoginBg: ThemeImageValue | string;
}

export type ThemeMode = 'light' | 'dark';

export class ThemeApi {
    /**
     * Get theme images for a given mode. The Java endpoint may auto-generate mainLogo /
     * squareLogo from the company name and persist them back, so callers should treat
     * the response as the new canonical state.
     * 按主题模式获取主题图片。Java 端会用公司名自动生成 mainLogo/squareLogo 并回写，
     * 因此调用方应把响应视为最新的权威状态。
     */
    getTheme = async (mode: ThemeMode = 'light'): Promise<ThemeImages> =>
        await get('/v2/platform/setting/theme', { mode });
}

export default new ThemeApi();
